<template>
  <div id="app">
    <div class="head">
      <div class="logobox">
                <div class="logon wfull">
                    <div class="logo Fl">
                        <h1 class="p25 animated fadeIn">
                            <router-link to="/" style="background: url('../static/img/logo.png'); background-size:100% 100%;background-repeat: no-repeat;margin-left:5px" title="奇克（上海）实业有限公司">
                                奇克（上海）实业有限公司</router-link>
                        </h1>
                    </div>
                    
          <nav class="cd-primary-nav">
            <a href="#cd-navigation" class="nav-trigger">
              <span>
                <em aria-hidden="true"></em>
                Menu
              </span>
            </a>
            <!-- .nav-trigger -->

            <ul id="cd-navigation">
                <li class="current"><router-link to="/">网站首页</router-link></li>
                <li class="cd-navigation-li3"><router-link to="/about">关于我们</router-link></li>
                <li><router-link to="/product">产品中心</router-link></li>
                <li class="cd-navigation-li3"><a  href="javascript:void">新闻中心</a></li>
                <li><router-link to="/contact">售后服务</router-link></li>
  
            </ul>
          </nav>

            </div>
            </div>
    </div>

    <div class="sfheader">
   <template>
  <el-carousel :interval="5000" arrow="always">
    <el-carousel-item v-for="item in 3" :key="item">
      <h3>
          <img :src="'../static/img/'+item+'.jpg'" />
      </h3>
    </el-carousel-item>
  </el-carousel>
</template>
    </div>

    <router-view></router-view>

    <div class="posts-nav wfull"></div>
    <div class="clear"></div>

    <div class="footer">
            <div class="dbnavhh wfull">
                <div class="blngwbd Fl" style="margin-left: 20px">
                    <h5>
                        主营产品
                    </h5>
                    <div class="menu-%e5%ba%95%e9%83%a8%e4%ba%8c-container">
                        <ul id="menu-%e5%ba%95%e9%83%a8%e4%ba%8c" class="footnav">
                        <li><a href="javascript:void">粉末丁腈橡胶</a></li>
                        <li><a href="javascript:void">氢氧化铝</a></li>
                        <li><a href="javascript:void">氢氧化镁</a></li>
                        </ul>
                    </div>
                </div>
                <div class="blngwbd Fl">
                    <h5>
                        合作伙伴
                    </h5>
                    <div class="menu-%e5%ba%95%e9%83%a8%e4%b8%89-container">
                        <ul id="menu-%e5%ba%95%e9%83%a8%e4%b8%89" class="footnav">
                        <li><a href="javascript:void">韩国KC集团</a></li>
                        <li><a href="javascript:void">韩国LG化学</a></li>
                        </ul>
                    </div>
                </div>
                <div class="da14n Fr">
                    <h5>
                        售后支持
                    </h5>
                    <h6 class="iconfont">
                        微信: 309816335
                    </h6>
                    <h6 class="iconfont">
                        传真：02139927292
                    </h6>
                    <p>
                        周一至周五 9:00-18:00
                    </p>
                </div>
                <div class="clear"></div>
            </div>
            <div class="footerDiv">
                <div class="footer01_end">
                
                    © 版权所有 奇克（上海）实业有限公司 | <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402006990">沪ICP备17021068号</a> 
                    <div class="clear">
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: grayscale;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    line-height: 440px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// App.vue?0eb99769